import React, { useEffect, useState } from "react";
import { Row, Col, Card, Form } from "react-bootstrap";
import { toast } from "react-toastify";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { schemecreate, schemedetail } from "../../../../services/master";
import { getrestrictions } from "../../../../services/setting";

/**
 * Total interest for the whole scheme, in rupees. The percentage is a rate on
 * the scheme total covering every due together, not a rate charged per due.
 */
function totalInterest(ipct, total) {
  const pct = parseFloat(ipct) || 0;
  const tot = parseFloat(total) || 0;
  return (tot * pct) / 100;
}

/**
 * Interest carried by a single due, in rupees. In percentage mode the overall
 * interest is spread evenly across the dues; in amount mode the figure entered
 * is already per due. Either way the preview stays in rupees.
 */
function interestPerDue(itype, ipct, total, amount, dues) {
  if (itype === "percentage") {
    const n = parseInt(dues, 10) || 0;
    if (n <= 0) {
      return "0.00";
    }
    return (totalInterest(ipct, total) / n).toFixed(2);
  }
  return (parseFloat(amount) || 0).toFixed(2);
}

export default function Addscheme() {
  const navigate = useNavigate();
  const { id } = useParams();
  const [sid, setSId] = useState("");
  const [schid, setSchId] = useState("");
  const [tamt, setTAmt] = useState("");
  const [schint, setSchInt] = useState("");
  const [schpct, setSchPct] = useState("");
  // 'amount' or 'percentage', from Settings for a new scheme and from the
  // scheme itself when editing, so an existing scheme keeps its own basis.
  const [inttype, setIntType] = useState("amount");
  const [schdue, setSchDue] = useState("");
  const [errorMsg, setErrorMsg] = useState("");

  const [schpre, setSchPre] = useState(false);
  const location = useLocation();
  const [urllink, setUrllink] = useState("");
  useEffect(() => {
    const path = location.pathname.split("/")[2];
    setUrllink(path);

    // A new scheme follows the Settings switch. An existing one keeps the
    // basis it was created with, overriding this once it loads below.
    if (path !== "schemedetail") {
      getrestrictions().then((res) => {
        if (res?.status === true && res.data?.details) {
          setIntType(
            res.data.details.scheme_interest_type === "percentage"
              ? "percentage"
              : "amount"
          );
        }
      });
    }

    if (path === "schemedetail") {
      schemedetail(id).then((res) => {
        if (res.status === true) {
          let arr = [];

          if (res.data.scheme !== null) {
            setSId(res.data.scheme.id);
            setSchId(res.data.scheme.scheme_id);
            setTAmt(res.data.scheme.total_amount);
            setSchInt(res.data.scheme.interest);
            if (res.data.scheme.interest_type === "percentage") {
              setIntType("percentage");
              setSchPct(res.data.scheme.interest_percentage ?? "");
            } else {
              setIntType("amount");
            }
            setSchDue(res.data.scheme.no_of_dues);
            for (let i = 0; i < res.data.entries.length; i++) {
              arr.push({
                id: res.data.entries[i].id,
                principle: res.data.entries[i].principal_amount,
                interest: res.data.entries[i].interest_amount,
                total: res.data.entries[i].total,
              });
            }
            setSchPre(true);
            setPScheme(arr);
          }
        }
      });
    }
  }, [location.pathname]);

  const handleAmt = (e) => {
    const regex = /^[0-9\b]+(\.[0-9]*)?$/;
    if (e.target.value === "" || regex.test(e.target.value)) {
      setTAmt(e.target.value);
    }
  };

  const handleInt = (e) => {
    const regex = /^[0-9\b]+(\.[0-9]*)?$/;
    if (e.target.value === "" || regex.test(e.target.value)) {
      setSchInt(e.target.value);
    }
  };

  const handlePct = (e) => {
    const regex = /^[0-9\b]+(\.[0-9]*)?$/;
    if (e.target.value === "" || regex.test(e.target.value)) {
      setSchPct(e.target.value);
    }
  };

  const handleDues = (e) => {
    const regex = /^[0-9\b]+$/;
    if (e.target.value === "" || regex.test(e.target.value)) {
      setSchDue(e.target.value);
    }
  };
  const [pscheme, setPScheme] = useState([]);
  function previewsch() {
    setSchPre(true);
    let arr = [];
    let prin = (tamt / schdue).toFixed(2);
    // Percentage entries are converted here, so the preview column below is
    // always a rupee figure.
    let inte = interestPerDue(inttype, schpct, tamt, schint, schdue);
    // Math.round(tamt / schdue);
    // let iamt= Math.round((schint*schdue)/schdue);
    for (let i = 0; i < schdue; i++) {
      let tsch = 0;
      tsch = parseFloat(prin) + parseFloat(inte);
      arr.push({
        id: 0,
        principle: prin,
        interest: inte,
        total: tsch.toFixed(2),
        // Math.round(tsch),
      });
    }
    setPScheme(arr);
  }

  function handlePrinciple(hdata, hid) {
    let arr = [...pscheme];
    arr[hid].principle = hdata;
    arr[hid].total =
      (parseFloat(arr[hid].principle) || 0) + (parseFloat(arr[hid].interest) || 0);
    setPScheme(arr);
  }
  function handleInterest(hdata, hid) {
    let arr = [...pscheme];
    arr[hid].interest = hdata;
    arr[hid].total =
      (parseFloat(arr[hid].principle) || 0) + (parseFloat(arr[hid].interest) || 0);
    setPScheme(arr);
  }

  function submitsch(e) {
    e.preventDefault();
    setErrorMsg("");
    const intvalue = inttype === "percentage" ? schpct : schint;
    if (schid !== "") {
      if (tamt !== "") {
        if (intvalue !== "") {
          if (schdue !== "") {
            setLoading(true);
            const temp = new FormData();
            temp.append("scheme", schid);
            temp.append("total_amount", tamt);
            // The backend recomputes the rupee amount in percentage mode; this
            // is the amount-mode value and the fallback.
            temp.append(
              "interest",
              interestPerDue(inttype, schpct, tamt, schint, schdue)
            );
            temp.append("interest_type", inttype);
            temp.append("interest_percentage", inttype === "percentage" ? schpct : "");
            temp.append("no_of_dues", schdue);

            if (urllink === "schemedetail") {
              temp.append("id", sid);
              for (let i = 0; i < pscheme.length; i++) {
                temp.append(`id_${i + 1}`, pscheme[i].id);
                temp.append(`principal_amount_${i + 1}`, pscheme[i].principle);
                temp.append(`interest_amount_${i + 1}`, pscheme[i].interest);
                temp.append(`total_${i + 1}`, pscheme[i].total);
              }
            } else {
              for (let i = 0; i < pscheme.length; i++) {
                temp.append(`principal_amount_${i + 1}`, pscheme[i].principle);
                temp.append(`interest_amount_${i + 1}`, pscheme[i].interest);
                temp.append(`total_${i + 1}`, pscheme[i].total);
              }
            }
            schemecreate(temp).then((response) => {
              if (response.status === true) {
                setLoading(false);
                toast.success(response.message);
                navigate("/master/schemelist");
              } else {
                setLoading(false);
                setErrorMsg(response.message);
              }
            });

          } else {
            setErrorMsg("Please Enter No of Dues");
          }
        } else {
          setErrorMsg(
            inttype === "percentage"
              ? "Please Enter Interest Percentage"
              : "Please Enter Interest"
          );
        }
      } else {
        setErrorMsg("Please Enter Total Amount");
      }
    } else {
      setErrorMsg("Please Enter Scheme Id");
    }
  }

  const [loading, setLoading] = useState(false);

  return (
    <div>
      <div className="page-header">
        <h2 className="main-content-title tx-24 mg-b-5">Add Scheme</h2>
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <a>Scheme</a>
          </li>
          <li className="breadcrumb-item active" aria-current="page">
            Add Scheme
          </li>
        </ol>
      </div>
      {loading && (
        <div className="loader-wrapper">
          <div className="loader"></div>
          <h3>Loading...Please do not go back or close the window.</h3>
        </div>
      )}
      {!loading && (
        <div className="content-body">
          <Row>
            <Col xl={12}>
              <Card>
                <Card.Header>
                  <h2 className="main-content-title tx-24 mg-b-5">
                    Add Scheme
                  </h2>
                </Card.Header>
                <Card.Body>
                  <Row>
                    <Col xl={4} sm={6}>
                      <div className="mb-3">
                        <label className="form-label">
                          Scheme ID <span className="text-danger"> * (Don't use any special character)</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter Scheme Id"
                          value={schid}
                          // onChange={(e) => setSchId(e.target.value)}
                          onChange={(e) => {
                            const value = e.target.value;

                            // Allow only letters, numbers, and spaces
                            const filteredValue = value.replace(/[^a-zA-Z0-9 ]/g, "");

                            setSchId(filteredValue);
                          }}
                        />
                      </div>
                    </Col>
                    <Col xl={4} sm={6}>
                      <div className="mb-3">
                        <label className="form-label">
                          Total Amount <span className="text-danger"> *</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter Total Amount"
                          value={tamt}
                          onChange={handleAmt}
                        />
                      </div>
                    </Col>
                    <Col xl={4} sm={6}>
                      <div className="mb-3">
                        <label className="form-label">
                          {inttype === "percentage"
                            ? "Total Interest %"
                            : "Interest Per Due ₹ Rs"}
                          <span className="text-danger"> *</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder={
                            inttype === "percentage"
                              ? "Enter Interest Percentage"
                              : "Enter Interest"
                          }
                          value={inttype === "percentage" ? schpct : schint}
                          onChange={inttype === "percentage" ? handlePct : handleInt}
                        />
                        {inttype === "percentage" && (
                          <small className="text-muted">
                            % of the total amount, spread over all dues. Total
                            interest: {totalInterest(schpct, tamt).toFixed(2)} ₹ Rs
                            &nbsp;|&nbsp; Per due:{" "}
                            {interestPerDue("percentage", schpct, tamt, schint, schdue)} ₹ Rs
                          </small>
                        )}
                      </div>
                    </Col>
                    <Col xl={4} sm={6}>
                      <div className="mb-3">
                        <label className="form-label">
                          No Of Dues <span className="text-danger"> *</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter No of Dues"
                          value={schdue}
                          onChange={handleDues}
                        />
                      </div>
                    </Col>
                  </Row>
                  {errorMsg && <span className="text-danger">{errorMsg}</span>}
                  <div className="text-end">
                    <a className="btn btn-success me-2" onClick={previewsch}>
                      Preview
                    </a>
                    <a
                      className="btn btn-info"
                      onClick={() => navigate("/master/schemelist")}
                    >
                      Back
                    </a>
                  </div>
                </Card.Body>
              </Card>
            </Col>
            {schpre && (
              <Col xl={12}>
                <Card>
                  <Card.Header>
                    <h2 className="main-content-title tx-24 mg-b-5">
                      Scheme preview
                    </h2>
                  </Card.Header>
                  <div className="table-container">
                    <div className="table-scroll">
                      <table className="responsive-table">
                        <thead>
                          <tr>
                            <th>Due No</th>
                            <th>Principle</th>
                            <th>Interest</th>
                            <th>Total</th>
                          </tr>
                        </thead>
                        <tbody>
                          {pscheme.map((item, index) => (
                            <tr key={index}>
                              <td>{index + 1}</td>
                              <td>
                                <input
                                  type="text"
                                  className="input-field"
                                  value={item.principle}
                                  onChange={(e) =>
                                    handlePrinciple(e.target.value, index)
                                  }
                                />
                              </td>
                              <td>
                                <input
                                  type="text"
                                  className="input-field"
                                  value={item.interest}
                                  onChange={(e) =>
                                    handleInterest(e.target.value, index)
                                  }
                                />
                              </td>
                              <td>
                                <input
                                  type="text"
                                  readOnly
                                  className="input-field total-field"
                                  value={item.total}
                                  disabled
                                />
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                    <div className="text-end mt-2">
                      <a className="btn btn-success me-2" onClick={submitsch}>
                        Submit
                      </a>

                    </div>
                  </div>
                </Card>
              </Col>
            )}
          </Row>
        </div>
      )}
    </div>
  );
}
